import { APP_INITIALIZER } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { RouterStateSerializer } from '@ngrx/router-store';
import { AppFacade } from './app.facade';

import { IRouterStateUrl } from './app.state.model';
import { EnvironmentConfig, EnvironmentLoaderService } from '@rci/environment-loader';
import { filter } from 'rxjs/operators';

export function stateInitializeFactory(appFacade: AppFacade, envLoader: EnvironmentLoaderService<EnvironmentConfig>) {
  return () => {
    return new Promise((resolve, _reject) => {
      return envLoader.environmentConfigLoaded$
        .pipe(filter(environmentConfigLoaded => environmentConfigLoaded))
        .subscribe(_ => {
          appFacade.initializeStore().then(resolve);
        });
    });
  };
}

export const stateInitializer = [
  {
    provide: APP_INITIALIZER,
    useFactory: stateInitializeFactory,
    multi: true,
    deps: [AppFacade, EnvironmentLoaderService],
  },
];

export class CustomSerializer implements RouterStateSerializer<IRouterStateUrl> {
  serialize(routerState: RouterStateSnapshot): IRouterStateUrl {
    const { url } = routerState;
    const { queryParams } = routerState.root;

    let state: ActivatedRouteSnapshot = routerState.root;
    while (state.firstChild) {
      state = state.firstChild;
    }

    const { params } = state;

    return { url, queryParams, params };
  }
}
